import {Controller} from "stimulus";
import Select2 from "select2";

export default class extends Controller {
  static targets = ['url']

  optgroupCache = {};
  termCache = "";

  connect() {
    this.loadSelectInput();
  }

  loadSelectInput() {
    const url = $(this.urlTarget).data('url')
    const inventoryItemId = $(this.urlTarget).data('inventory-item-id')

    $('#envida-modal').on('shown.bs.modal', () => {
      $('.select2-ajax').select2({
        dropdownParent: $('#envida-modal'),
        placeholder: "Search",
        minimumInputLength: 0,
        cache: true,
        templateResult: this.formatOption,
        ajax: {
          url: `/${url}.json`,
          dataType: 'json',
          delay: 250,
          data: params => ({
            q: params.term,
            page: params.page,
            inventory_item_id: inventoryItemId
          }),
          processResults: this.processResults
        }
      });
      $('.select2-ajax').on('change', (e) => {
        this.optgroupCache = {};
        this.termCache = "";
      });
    });

  }

  processResults = (data, params) => {
    params.page = params.page || 1;
    if (this.termCache !== params.term) this.optgroupCache = {}
    this.termCache = params.term

    const oldResults = data.items;

    let newResults = [];

    oldResults.forEach(optgroup => {
      const optgroupTitle = optgroup.text;
      let title = this.optgroupCache[optgroupTitle] ? " " : optgroupTitle

      this.optgroupCache[optgroupTitle] = optgroup.children;
      newResults.push({
        text: title,
        children: optgroup.children
      });

    });

    return {
      results: newResults,
      pagination: this.getPaginationStatus(params.page, data.pagination.total_pages)
    };
  };

  getPaginationStatus(page, totalPages) {
    return {
      more: page < totalPages
    };
  }

  formatOption(user, container, $el) {
    if (user.loading) {
      return user.text;
    }

    const text = user.details ? `(${user.details})` : "";
    const $container = $(
      `<div>${user.text}<span class="role"> ${text}</span></div>`
    );

    return $container;
  }
}
